import { Box, Stack, Text } from '@chakra-ui/react';
import { CaretLeft } from '@phosphor-icons/react';
import { NavigateFunction } from 'react-router-dom';

interface BreadcrumbNavigationProps {
  candidateId?: string;
  candidateName?: string;
  onNavigate: NavigateFunction;
}

export function BreadcrumbNavigation({
  candidateId,
  candidateName,
  onNavigate
}: BreadcrumbNavigationProps) {
  return (
    <Stack direction="row" alignItems="center" justifyContent="center" h="100%" gap="16px">
      <Box as="button" onClick={() => onNavigate(`/candidate`)} cursor="pointer">
        <CaretLeft size={28} color="#545454" />
      </Box>
      <Box fontSize="16px" color="neutrals.700">
        <Text
          as="span"
          cursor="pointer"
          onClick={() => onNavigate(`/candidate`)}
          _hover={{ textDecoration: 'underline' }}
        >
          Candidate Management
        </Text>{' '}
        {candidateId && candidateName && (
          <>
            <Text as="span">/ </Text>
            <Text
              as="b"
              cursor="pointer"
              onClick={() => onNavigate(`/candidate/${candidateId}`)}
              _hover={{ textDecoration: 'underline' }}
            >
              {candidateName}
            </Text>{' '}
          </>
        )}
      </Box>
    </Stack>
  );
}
